export default {
  title: 'PROVIDER PROFILE SETTINGS',
  items: {
    EnableTCPDocToTNC: {
      label: 'Enable TCP doc to TNC & TCP profiles',
      type: 'boolean'
    }
  }
}
  


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/provider-profile-settings.js